export default __webpack_public_path__ + "static/22_Winners-52c935a5a9bfca518cd16e96c6dc9c24.jpg";